
import { common } from './common/ja';
import { products } from './products/ja';
import { pricing } from './pricing/ja';
import { solutions } from './solutions/ja';

export const ja = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
